import React from 'react';

interface CardSkeletonProps {
  height?: string;
  className?: string;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ height = 'h-32', className = '' }) => {
  return (
    <div className={`animate-pulse bg-gray-200 rounded-lg ${height} w-full ${className}`}>
      <div className="h-4 bg-gray-300 rounded w-3/4 mx-auto mt-3"></div>
      <div className="h-8 bg-gray-300 rounded w-1/2 mx-auto mt-4"></div>
      <div className="h-4 bg-gray-300 rounded w-2/3 mx-auto mt-4"></div>
    </div>
  );
};

export default CardSkeleton;
